module.exports = __webpack_public_path__ + "static/media/gestioneEnti.5e698a7c.png";